// extracted by mini-css-extract-plugin
export default {"divider":"Resizer_divider__O-5J8"};